import { render } from "./UserDeactivateAccount.vue?vue&type=template&id=bacb1a02"
import script from "./UserDeactivateAccount.vue?vue&type=script&lang=js"
export * from "./UserDeactivateAccount.vue?vue&type=script&lang=js"

import "./UserDeactivateAccount.vue?vue&type=style&index=0&id=bacb1a02&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__